<template>
  <div class="agree-policy">
    <Agreement v-if="showStatement" :policyInfo="policyInfo" :showSystemPolicy="showSystemPolicy" :isApplicationAgreement="isApplicationAgreement" :isTalentAgreement="isTalentAgreement" @submit="handleSubmit"></Agreement>
  </div>
</template>

<script>
import { addI18nProperty } from '@/i18n'
import Agreement from '@/components/agreement/agreementContent.vue'
import { mapActions } from 'vuex'
import { deviceType } from '@/utils/common'
import { mixedRouterPush } from '@/router/routes'

export default {
  components: {
    Agreement
  },
  data () {
    return {
      htmlContent: null,
      showStatement: false,
      jobCompanyId: null,
      showSystemPolicy: true,
      policyInfo: {}
    }
  },
  computed: {
    jobId () {
      return this.$route.query.job_id
    },
    companyId () {
      return this.$route.query.company_id
    },
    isApplicationAgreement () {
      return Boolean(this.jobId)
    },
    isTalentAgreement () {
      return this.$route.query.is_talent_agreement === '1'
    }
  },
  created () {
    this.initPageData()
  },
  methods: {
    ...mapActions('personal', ['getAgreementStatus', 'updateAgreement']),
    async initPageData () {
      this.showStatement = false
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.getAgreementStatus({
          policy_info: '1',
          application: this.isApplicationAgreement ? '1' : '0',
          job_id: this.jobId,
          company_id: this.companyId
        })
        if (resp) {
          this.jobCompanyId = resp.company_id
          this.showSystemPolicy = !resp.is_agreed_system_policy
          if (resp.is_agreed) {
            this.openNextPage(true)
            return
          }
          this.policyInfo = resp.policy_info
          addI18nProperty(this.policyInfo, 'companyName', 'company_cn_name', 'company_en_name')
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
        this.showStatement = true
      }
    },
    openNextPage (isAgree) {
      const query = this.$route.query
      let url = isAgree ? query.back : query.reject_back
      if (this.isTalentAgreement) {
        url = deviceType.isPc ? `/recruiting/company/${this.companyId}/job-list` : `/mobile-web-more-jobs/${this.companyId}`
      } else {
        if (!url) {
          if (deviceType.isPc) {
            url = `/recruiting/personal/home?company_id=${this.companyId || this.jobCompanyId || ''}`
          } else {
            url = `/recruiting/personal/?company_id=${this.companyId || this.jobCompanyId || ''}`
          }
        }
      }
      if (!url.startsWith('http')) {
        url = this.$DjangoBaseUrl(url)
      }
      mixedRouterPush(url)
    },
    async handleSubmit (isAgree, agreeItemIds) {
      this.$eventBus.$emit('showLoading', true)
      try {
        const agreementInfo = {
          application: this.isApplicationAgreement ? '1' : '0',
          job_id: this.jobId,
          company_id: this.companyId,
          is_agree: isAgree,
          agree_item_ids: agreeItemIds,
          is_talent_agreement: this.isTalentAgreement && !this.jobId
        }
        const resp = await this.updateAgreement(agreementInfo)
        if (resp) {
          this.openNextPage(isAgree)
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.agree-policy {
  height: 100vh;
  background: #000;
}
</style>
